import { KeysTab } from '@proccess/@interface';
import { TAB_KEYS } from '@proccess/constants';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ReqSchedules, ScheduleStep, Scheduled, SetDataSchedule } from './@define/types';

const initialState = {
  schedule_step: {
    subject: [],
    doctor: [],
    service: [],
    date: [],
    time: [],
  } as ScheduleStep,
  tab_active: TAB_KEYS.patient,
  scheduled: {
    subject: {},
    doctor: {},
    service: {},
    date: { id: '' },
    time: {},
    booking_reason: '',
  } as Scheduled,
};

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    resetAnyKeySchedule: (
      state,
      action: PayloadAction<{ key: keyof typeof initialState; data: any }>
    ) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    setActiveTab: (_state, _action: PayloadAction<{ key: KeysTab }>) => {
      const { key } = _action.payload;
      _state.tab_active = key;
    },
    requestScheduleStep: (_state, _action: ReqSchedules) => undefined,
    saveScheduleStep: (state, action: PayloadAction<{ data: any; step: string }>) => {
      const { data, step } = action.payload;
      state.schedule_step = {
        ...state.schedule_step,
        [step]: data,
      };
    },
    setDataScheduled: (state, action: SetDataSchedule) => {
      const { data, step, other, reset_step } = action.payload;

      reset_step?.forEach((key) => {
        (state.scheduled as any)[key] = {};
      });

      state.scheduled = {
        ...state.scheduled,
        [step]: {
          ...data,
          other,
        },
      };
    },
    saveBookingReason: (_state, _action: PayloadAction<{ data: string }>) => {
      const { data } = _action.payload;
      _state.scheduled.booking_reason = data;
    },
    resetStepInScheduled: (state, action: PayloadAction<{ step?: string; steps?: string[] }>) => {
      const { step = '', steps } = action.payload;

      if (steps) {
        steps.forEach((item) => {
          state.scheduled = {
            ...state.scheduled,
            [item]: {},
          };
        });
      } else {
        state.scheduled = {
          ...state.scheduled,
          [step]: {},
        };
      }
    },
  },
});

export default scheduleSlice;
